export default __webpack_public_path__ + "static/media/mastercards.fdc9ad7b.png";